import React from "react";
import ReturnForm from "../components/ReturnForm";

export default function ReturnNew() {
  return <ReturnForm mode="new" />;
}
